<template>
  <div>
    <ResetPasswordDialog
      v-if="valid"
      ref="reset_password_dialog"
      :user_id="userId"
      :request_change_confirme="true"
      :callback="callback"
    />
    <div v-else class="text-center">
      <p>Validando link temporal de solicitud de cambio de contraseña.</p>
      <v-progress-circular
        :size="100"
        color="primary"
        indeterminate
      >
      </v-progress-circular>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import ResetPasswordDialog from "@/components/dialog/ResetPassword"
import messageMixin from "@/mixins/common"

export default {
  name: "request-password-change",
  mixins: [messageMixin],
  components: {
    ResetPasswordDialog,
  },
  data() {
    return {
      userId: null,
      loading: true,
      valid: false,
      callback: () => { window.location.assign('../login') }
    }
  },
  mounted() {
    this.isValidateTemporaryLink()
  },
  methods: {
    ...mapActions("Auth", ["validateTemporaryLink"]),
    isValidateTemporaryLink() {
      this.loading = true
      this.valid = false
      this.validateTemporaryLink(this.$route.params.link_temporal)
      .then(response => {
        if (response) {
          this.userId = response
          this.valid = true
          return
        }

        this.errorMessage(this.messageError, this.callback)
      })
      .finally(() => (this.loading = false))
    }
  },
  computed: {
    ...mapState("Auth", ["messageError"])
  },
}
</script>
